import { apiV2, errorHandler } from "./index";
import {
  API_ERROR,
  FETCH_GENERAL_INFO,
  UPDATE_GENERAL_INFO,
  DELETE_GENERAL_INFO,
  CREATE_GENERAL_INFO
} from "../constants/ActionTypes";
import Swal from "sweetalert2";

export const fetchGeneralInfo = () => async (dispatch) => {
  try {
    const response = await apiV2.get('/general-info');
    dispatch({
      type: FETCH_GENERAL_INFO,
      payload: response.data
    });
  } catch (error) {
    console.error('Error fetching general info:', error);
    errorHandler(dispatch, error.response, API_ERROR);
  }
};

export const createGeneralInfo = (data) => async (dispatch) => {
  try {
    await apiV2.put(`/general-info/${encodeURIComponent(data.general_info_key)}`, {
      general_info_value: data.general_info_value,
      general_info_notes: data.general_info_notes
    });
    dispatch({
      type: CREATE_GENERAL_INFO,
      payload: data
    });
  } catch (error) {
    console.error('Error creating general info:', error);
    errorHandler(dispatch, error.response, API_ERROR);
    throw error;
  }
};

export const updateGeneralInfo = (data) => async (dispatch) => {
  try {
    const response = await apiV2.put(`/general-info/${encodeURIComponent(data.general_info_key)}`, {
      general_info_value: data.general_info_value,
      general_info_notes: data.general_info_notes
    });
    dispatch({
      type: UPDATE_GENERAL_INFO,
      payload: data
    });
    return response.data;
  } catch (error) {
    console.error('Error updating general info:', error);
    errorHandler(dispatch, error.response, API_ERROR);
    throw error;
  }
};

export const deleteGeneralInfo = (key) => async (dispatch) => {
  try {
    await apiV2.delete(`/general-info/${encodeURIComponent(key)}`);
    dispatch({
      type: DELETE_GENERAL_INFO,
      payload: key
    });
  } catch (error) {
    console.error('Error deleting general info:', error);
    errorHandler(dispatch, error.response, API_ERROR);
    throw error;
  }
};
